import { SubJobAppointment } from 'models';

export function hasHired(appointment: SubJobAppointment) {
    return appointment.pairings.some((pairing) => ['ON_STAFF', 'COMPLETED'].includes(pairing.status));
}
